import { useState, useEffect } from "react";
import { useParams} from "react-router-dom";
import axios from 'axios';
import { G_API } from '../../constants/globalVar';
import ReactGA from 'react-ga4';
import SocialShareButtons from "../Button/SocialShareButtons";

export default function DetailPage(){
    const { id } = useParams();
    const [item, setItem] = useState(null);
    const [formattedDate, setFormattedDate] = useState('');
    useEffect(() => {
        var data = {
            id: id
        };
        var config = {
            method: 'POST',
            maxBodyLength: Infinity,
            url: G_API+'courses/COURSE_LIST',
            headers: { },
            data : data
        };

        axios(config)
        .then( (response) => {
            const item = response.data.DATAS;
            setItem(item);
            if (item.start_date) {
                setFormattedDate(item.start_date.substring(0, 10));
            }
        })
        .catch(function (error) {
            console.error(error);
        });
    }, [id]);

    const isRegistrationLinkValid = item && item.registeration_link &&
                                   item.registeration_link !== 'N/A' &&
                                   item.registeration_link !== 'NA' &&
                                   item.registeration_link !== '-';

    const handleEnrollClick = (event) => {
        if (!isRegistrationLinkValid) {
            event.preventDefault();
        }
    };

    function openShare() {
        ReactGA.event({
            category: 'Course',
            action: 'course_share_btn_clicked',
            label: item ? item.title : 'Course Share',
        });
    }

    return (
        <>
        {item ? (
            <div>
                <div id="header-carousel" className="carousel slide" data-bs-ride="carousel" >
                    <div className="carousel-inner" >
                        <div className="carousel-item active">
                            {item.cover_img?.src ? (
                                <img className="w-100 small-slider" src={item.cover_img.src} alt="" />
                            ): (
                                <img className="w-100 small-slider" src='/assets/img9.jpg' alt="" />
                            )}
                            <div className="carousel-caption">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-7 pt-0">
                                            <h1 className="display-4 text-white mb-1 mt-2 pt-2 animated slideInDown">
                                                {item.title}
                                            </h1>
                                            <p className="fs-5 text-white-50 mb-5 animated slideInDown">We make free online courses, information sharing events, and volunteer
    work for community development</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="container my-4">
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <h2 className="mb-4">{item.title}</h2>
                                <p className="text">
                                    <span dangerouslySetInnerHTML={{ __html: item.description }} /></p>
                            </div>
                            <div className="col-sm-12 col-md-6 text-center">
                                {item.feature_img?.src ? (
                                    <img
                                        className="course-img w-full rounded-md"
                                        src={item.feature_img.src}
                                        alt="Feature"
                                        style={{ objectFit:'cover',width:'100%' ,minHeight:'500px', height:'auto' }}
                                    />
                                ) : (
                                    <img
                                        className="course-img w-full rounded-md"
                                        src="/assets/images/BlogTemp.png"
                                        alt="Placeholder"
                                        style={{ objectFit:'cover',width:'100%' ,minHeight:'500px', height:'auto' }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="courseNav d-flex justify-content-between px-5 align-items-center">
                        <div className="tag d-flex justify-content-between align-items-center">
                            <div className="pe-2"><i className="bi bi-hourglass-split"></i></div>
                                <div className="navText">
                                    <div>{item.course_lenght}</div>
                            </div>
                        </div>
                        <div className="tag d-flex justify-content-between align-items-center">
                            <div className="pe-2"><i className="bi bi-person-video3"></i></div>
                                <div className="navText">
                                    <div>{item.instructor_name}</div>
                            </div>
                        </div>
                        <div className="tag d-flex justify-content-between align-items-center">
                            <div className="pe-2"><i className="bi bi-currency-dollar"></i></div>
                                <div className="navText">
                                    <div>{item.fee}</div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="card my-5 ps-3 shadow-sm" style={{width: "18rem"}}>
                            <div className="py-4">
                              <h5 className="card-title">Starts {formattedDate}</h5>
                            </div>
                            
                            {isRegistrationLinkValid ? (
                                <a
                                    onClick={handleEnrollClick}
                                    href={isRegistrationLinkValid ? item.registeration_link : '#'}
                                    {...(isRegistrationLinkValid ? { target: "_blank", rel: "noreferrer" } : {})}
                                    className={`cardBtn mb-4 w-200`}
                                >{isRegistrationLinkValid ? 'Enroll Now' : 'Enrollment Closed'}</a>
                            ) : (
                                <button type="button" className="cardBtn mb-4 w-200" >Enrollment Closed</button>
                            )}

                            {item.fin_aid ? (
                                <button type="button" className="cardBtn2 mb-4" >Scholarship Available</button>
                            ):(
                                <div></div>
                            )}
                        </div>
                    </div>
                    <div className="courseNav d-flex justify-content-between px-5 align-items-center">
                        <div className="tag">
                            <div className="navText">
                                <a href="#learn" className="no-link">What you'll learn</a>
                            </div>
                        </div>
                        <div className="tag">
                            <div className="navText">
                                <a href="#resource" className="no-link">Learning Resources</a>
                            </div>
                        </div>
                        <div className="tag">
                            <div className="navText">
                                <a href="#instructor" className="no-link">Instructor</a>
                            </div>
                        </div>
                        <div className="tag">
                            <div className="navText">
                                <span className="text-capitalize">{item.course_type ?? 'certificate'}</span>
                            </div>
                        </div>
                    </div>

                    <div className="container mt-4">
                        <div className="row">
                            <div className="col-12"><h3 id="learn">What will you learn</h3>
                                <p className="text">
                                    <span dangerouslySetInnerHTML={{ __html: item.what_will_learn }} />
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12"><h3 id="resource">Learning Resources</h3>
                                <p className="text">{item.learn_resource}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <h3 className="mb-4" id="instructor">Instructor</h3>
                                <h6 className="mt-4">{(item.instructor_name && item.instructor_name !== undefined && item.instructor_name !== null) ? item.instructor_name : 'Instructor Name Not Available'}</h6>
                                {(item.instructor_description && item.instructor_description !== undefined && item.instructor_description !== null) ? <p dangerouslySetInnerHTML={{ __html: item.instructor_description }} /> : null}
                            </div>
                        </div>
                        <div className="row">
                            <span className="opacity-50">Tags: </span>
                            <span>
                            {((item.post_tags !== undefined) ? item.post_tags.map((tag, index) => (
                                <a key={index} className="badge bg-secondary me-1 text-decoration-none" href={tag.title ? `/courses/tags/${tag.title}` : "#"}>
                                    {tag.title}
                                </a>
                            )) : null)}
                            </span>
                        </div>
                        <div className="d-flex justify-content-center mt-4">
                            <SocialShareButtons title={item.title} onClick={openShare} />
                        </div>
                    </div>
                </div>
            </div>
            ) : <div>
                <span>Loading...</span>
            </div> }
        </>
    );
}
